import microuniversoApi from "app/api/microuniversoApi"
import { useAppSelector } from "app/redux/hooks"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import React, { useEffect, useState, useCallback } from "react"
import { DadosSimularDesconto, DadosSimularDescontoSaida, ModalSimularDesconto } from "./ModalSimularDesconto" //"./modalSimularDesconto"
import * as R from 'ramda'
import { Parametro, ParametroPorItem } from "app/types/Parametro"
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros"
import globalMU from "globalMU"
import { tratamentoErroPadrao } from "app/use-cases"
import { alterarPrecoItem as alterarPrecoItemUseCase } from "app/use-cases"
import { simularDescontoItem } from "app/use-cases/orcamento/simularDescontoItem"

export type ModalSimularDescontoContainerProps = {
  item: IItemOrcamento
  onAplicado: () => void
  onCancelar: () => void
}

export const ModalSimularDescontoContainer = (props: ModalSimularDescontoContainerProps) => {
  const [dadosSimulacaoDesconto, setDadosSimulacaoDesconto] = useState<DadosSimularDesconto | null>(null)
  const [dadosDescontoCalculado, setDadosDescontoCalculado] = useState<DadosSimularDesconto>({})
  const [parametros, setParametros] = useState<Parametro[]>([])
  const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([])
  const [parametrosCarregados, setParametrosCarregados] = useState(false)
  const [dadosSimulacaoDescontoCarregados, setDadosSimulacaoDescontoCarregados] = useState(false)
  const [descontoCalculado, setDescontoCalculado] = useState(false)

  const orcamento = useAppSelector(state => state.orcamento)

  const atualizarParametros = useCallback(async () => {
    const param = await obterParametros({
      nomes: [
        "CASAS_DECIMAIS_PRECO_VENDA",
        "DESCONTO_ACUMULADO",
        "PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO"
      ],
    });
    setParametros(param);

    const paramFilial = await obterParametrosPorOidItem({
      nomes: [
        "ORCWEB_UTILIZA_DESCONTO_MAXIMO_BONIFICACAO_AVANCADOS",
        "PERMITE_ALTERAR_PRECO_PARA_MAIOR_ORCAMENTO"
      ],
      oidItem: orcamento.OidFilialOrcamento
    });
    setParametrosPorFilial(paramFilial);

    setParametrosCarregados(true);
  }, [orcamento.OidFilialOrcamento]);

  const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor
  const valorParametroPorFilial = (nome: string) => parametrosPorFilial.find((p) => p.Nome == nome)?.Valor

  const carregarDadosSimulacaoDesconto = useCallback(async () => {
    const dados = dadosSimulacaoDesconto || {
      PercentualBonificacao: 0,
      PercentualDesconto: 0,
      Preco: props.item.PrecoProduto,
      ValorNaoIncideDesconto: (props.item.PrecoUnitServAgreg ?? 0) + (props.item.PrecoUnitServAgreg ?? 0), // 458061_458098 PA447380
      PreservaDesconto: props.item.PreservaDesconto,
      DescontoPendente: props.item.DescontoPendente,
      PercentualMaximoDesconto: props.item.PercentualMaximoDesconto, // 448892
      PendenciaDescontoSobreOferta: props.item.PendenciaDescontoSobreOferta
    };

    const simulado = await microuniversoApi.Orcamento.simularDesconto({
      codigoObjetoItem: props.item.Identificador,
      identificadorOrcamento: orcamento.IdentificadorOrcamento,
      percentualBonificacao: dados.PercentualBonificacao,
      percentualDesconto: dados.PercentualDesconto,
      percentualDescontoGeralOrcamento: orcamento.PercentualDesconto,
      preco: dados.Preco,
      preservaDesconto: dados.PreservaDesconto
    });

    setDadosSimulacaoDesconto(simulado);
    setDadosSimulacaoDescontoCarregados(true);
  }, [dadosSimulacaoDesconto, orcamento.IdentificadorOrcamento, props.item]);

  const simularDesconto = async (dadosSimulacao: DadosSimularDescontoSaida) => {
    try {
      const dados = await simularDescontoItem({
        percentualDesconto: dadosSimulacao.PercentualDesconto,
        preco: dadosSimulacao.Preco,
        preservaDescontoModificadoManualmente: dadosSimulacao.PreservaDescontoModificadoManualmente,
        preservaDesconto: dadosSimulacao.PreservaDesconto,
        precoUnitarioTabela: props.item.PrecoUnitarioTabela,
        identificadorItem: props.item.Identificador,
        identificadorOrcamento: orcamento.IdentificadorOrcamento,
        percentualBonificacao: dadosSimulacao.PercentualBonificacao,
        percentualDescontoOrcamento: orcamento.PercentualDesconto,
      });

      setDadosSimulacaoDesconto(dados);
      setDadosDescontoCalculado(dados);
      setDescontoCalculado(true);
    } catch (erro) {
      tratamentoErroPadrao(erro);
    }
  }

  const aplicar = async () => {
    globalMU.blockUI();

    try {
      await alterarPrecoItemUseCase({
        identificadorItem: props.item.Identificador,
        preco: dadosDescontoCalculado.Preco,
        percentualDesconto: dadosDescontoCalculado.PercentualDesconto,
        percentualBonificacao: dadosDescontoCalculado.PercentualBonificacao,
        PARAMETRO_PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO: valorParametro("PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO"),
        preservaDesconto: dadosDescontoCalculado.PreservaDesconto
      });
    } catch (erro) {
      tratamentoErroPadrao(erro);
    } finally {
      globalMU.unblockUI();
      props.onAplicado();
    }
  }

  const numeroCasasDecimaisPreco = () => isNaN(Number(valorParametro("CASAS_DECIMAIS_PRECO_VENDA") || undefined)) ? 2 : Number(valorParametro("CASAS_DECIMAIS_PRECO_VENDA"))

  const handleAumentarPreco = async (valor: number) => { // 462697
    globalMU.blockUI();

    try {
      await alterarPrecoItemUseCase({
        identificadorItem: props.item.Identificador,
        preco: valor, // 462697
        percentualDesconto: null,
        percentualBonificacao: null,
        PARAMETRO_PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO: valorParametro("PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO"),
        preservaDesconto: null
      });
    } catch (erro) {
      tratamentoErroPadrao(erro);
    } finally {
      globalMU.unblockUI();
      props.onAplicado();
    }
  }

  useEffect(() => {
    const executarFuncoes = async () => {
        await Promise.all([
          atualizarParametros(),
          carregarDadosSimulacaoDesconto()
        ]) 
    }

    executarFuncoes()
}, [])
  

  const modal = () => (
    <ModalSimularDesconto
      somenteLeitura={orcamento.SomenteLeitura} // 466531
      descontoCalculado={descontoCalculado}
      item={props.item}
      dadosSimularDesconto={dadosSimulacaoDesconto}
      onManterDadosAlteradoParaCalcular={() => setDescontoCalculado(false)}
      numeroCasasDecimaisPreco={numeroCasasDecimaisPreco()}
      permitirAlterarPrecoParaMaior={valorParametroPorFilial("PERMITE_ALTERAR_PRECO_PARA_MAIOR_ORCAMENTO") == "S"} // 462697
      exibirDescontoMaximoBonificacaoAvancados={valorParametroPorFilial("ORCWEB_UTILIZA_DESCONTO_MAXIMO_BONIFICACAO_AVANCADOS") == "S"}
      exibirCheckboxPreservarDesconto={valorParametro("DESCONTO_ACUMULADO") == "S" && valorParametro("PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO") == "S"}
      onAplicar={aplicar}
      onAumentarPreco={handleAumentarPreco} // 462697
      onSimular={simularDesconto}
      onErrorValidacao={(mensagemErroSimularDesconto) => globalMU.showErrorMessage(mensagemErroSimularDesconto)}
      onCancelar={props.onCancelar}
    />
  );

  return (
    <>
      {dadosSimulacaoDesconto && parametrosCarregados && dadosSimulacaoDescontoCarregados && modal()}
    </>
  );
}
